import { render, staticRenderFns } from "./trash-paper-restore.html?vue&type=template&id=15818fa4&scoped=true&external"
import script from "./trash-paper-restore.js?vue&type=script&lang=js&external"
export * from "./trash-paper-restore.js?vue&type=script&lang=js&external"
import style0 from "./trash-paper-restore.scss?vue&type=style&index=0&id=15818fa4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15818fa4",
  null
  
)

export default component.exports